import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ImgQuery } from '../../services';
import { MarketingOrderedText } from '../../../common';
import { MarketingLandingGtmTrayData } from '../../interfaces/marketing-landing-gtm-tray-data.interface';
import { GoogleTagManagerEventAction } from '../../enums';
import { MarketingStudioViewModel } from './marketing-studio.view-model';

@Component({
  selector: 'osn-shared-marketing-studio',
  templateUrl: './marketing-studio.component.html',
  styleUrls: ['./marketing-studio.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MarketingStudioComponent implements OnInit {
  @Input() public vm: MarketingStudioViewModel;
  @Output() public measureStudioTrayButtonClick: EventEmitter<MarketingLandingGtmTrayData> = new EventEmitter();
  public imgQuery: ImgQuery;

  public get orderedStudioImgs(): Array<MarketingOrderedText> {
    return this.vm.studioImageUrls.slice().sort((imgA, imgB) => imgA.order - imgB.order);
  }

  public get buttonText(): string {
    return this.vm?.button?.labelLocalized[this.translateService.currentLang];
  }

  constructor(private readonly translateService: TranslateService) {}

  public ngOnInit(): void {
    this.imgQuery = {
      XS: 90,
      SM: 111,
      MD: 150,
      LG: 196,
      XL: 281,
    };
  }

  public onStudioTrayButtonClick(): void {
    this.measureStudioTrayButtonClick.emit({
      buttonLabel: this.vm.button.labelLocalized.en,
      type: GoogleTagManagerEventAction.BodyCtaClick,
      trayIndex: this.vm.trayIndex,
    });
  }
}
